export const surroundingOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '危険無し' },
  { value: '2', text: '不明確' },
  { value: '3', text: '危険あり' }
]

export const differentialSettlementOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無し又は軽微' },
  { value: '2', text: '著しい床、屋根の落ち込み、浮き上がり' },
  { value: '3', text: '小屋組の破壊、床全体の沈下' }
]

export const basicsOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無被害' },
  { value: '2', text: '部分的' },
  { value: '3', text: '著しい(破壊あり)' }
]

export const firstFloorSlopeOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '1/60以下' },
  { value: '2', text: '1/60～1/20' },
  { value: '3', text: '1/20超' }
]

export const wallOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '軽微なひび割れ' },
  { value: '2', text: '大きな亀裂、剥落' },
  { value: '3', text: '落下の危険あり' }
]

export const corrosionOrTermiteOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無し' },
  { value: '2', text: '一部の断面欠損' },
  { value: '3', text: '著しい断面欠損' }
]

export const settlementSlopeSteelOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '1/300以下' },
  { value: '2', text: '1/300～1/100' },
  { value: '3', text: '1/100超' }
]

export const slopeOptions = [
  { value: '-1', text: '未選択' },
  { text: '傾斜を生じた階の上の階数が1階以下の場合', disabled: true },
  { value: '1', text: '1/100以下' },
  { value: '2', text: '1/100～1/30' },
  { value: '3', text: '1/30超' },
  { text: '傾斜を生じた階の上の階数が2階以上の場合', disabled: true },
  { value: '4', text: '1/200以下' },
  { value: '5', text: '1/200～1/50' },
  { value: '6', text: '1/50超' }
]

export const bucklingOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無し' },
  { value: '2', text: '局部座屈あり' },
  { value: '3', text: '全体座屈あるいは著しい局部座屈' }
]

export const braceOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '20%以下' },
  { value: '2', text: '20%～50%' },
  { value: '3', text: '50%超' }
]

export const pillarBeamJointOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無し' },
  { value: '2', text: '一部破断あるいは亀裂' },
  { value: '3', text: '20%以上の破断' }
]

export const pillarBaseOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無被害' },
  { value: '2', text: '部分的' },
  { value: '3', text: '著しい' }
]

export const corrosionOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: 'ほとんど無し' },
  { value: '2', text: '各所に著しい錆' },
  { value: '3', text: '孔所が各所に見られる' }
]

export const settlementSlopeOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '1/60以下' },
  { value: '2', text: '1/60～1/30' },
  { value: '3', text: '1/30超' }
]

export const partsDamageGte3Options = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '無し' },
  { value: '2', text: 'あり' }
]

export const groundDestructionSettlementOptions = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '0.2m以下' },
  { value: '2', text: '0.2m～1.0m' },
  { value: '3', text: '1.0m超' }
]

export const pillarDamage5Options = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '1%以下' },
  { value: '2', text: '1%～10%' },
  { value: '3', text: '10%超' }
]

export const pillarDamage4Options = [
  { value: '-1', text: '未選択' },
  { value: '1', text: '10%以下' },
  { value: '2', text: '10%～20%' },
  { value: '3', text: '20%超' }
]
